export default {
    direction: "rtl",
    common: {
        enterNationalCodeAndMobile:'کد ملی و شماره موبایل خود را وارد نمایید',
        showExamResult:'مشاهده نتیجه آزمون',
        studentAcademicStatus: 'وضعیت علمی دانش پژوه',
        libBooks:'کتابخانه',
        changeUserPassword:'تغییر پسورد',
        reportSurveysDetail:'گزارش تفصیلی ارزیابی',
        userCourses:'دروس دانش پژوه',
        levels:'پایه های تحصیلی',
        tuitionPayed:'شهریه های پرداخت شده',
        monthlyPayments:'پرداخت های ماهانه',
        tuitionPayment:'پرداخت شهریه',
        financialSetting:'تنظیمات مالی',
        reportCard:'کارنامه',
        actionGrade:'نمره‌دهی به رفتار',
        evaluationactions:'ارزش‌گذاری رفتارها',
        evaluationActions:'ارزش‌گذاری رفتارها',
        actions:'رفتارها',
        fullProfileStudent:'مشخصات کامل دانش پژوه',
        copyStudentToOtherMerchant:'کپی کردن دانش پژوه در شعبه دیگر',
        propaganda:'تبلیغ',
        changeUserToStudentRole:'تبدیل کاربر به دانش پژوه',
        changeUserToRole:'تبدیل کاربر به نقش',
        itemsPerPage:'تعداد در صفحه',
        generalSpecifications:'مشخصات عمومی',
        administrativeInformation:'مشخصات اداری',
        uploadDocuments:'بارگزاری مدارک',
        gradeReport:'گزارش نمرات',
        updateUser:'بروزرسانی پروفایل',
        home:'پیشخوان',
        permissions:'دسترسی ها',
        teacherAbsenceReport:'گزارش غیبتهای اساتید',
        reportTeacherAbsence:'گزارش غیبتهای اساتید',
        grades:'نمرات',
        reportStudyDiscussion:'گزارش مطالعات و مباحثات',
        reportStudy:'گزارش مطالعات و مباحثات',
        reportAbsence:'گزارش غیبت ها',
        reportSurveys : 'گزارش ارزیابی',
        surveyDescriptionLabel:'ابتدا نمرات همه دانش پژوهان را وارد کنید سپس دکمه ذخیره را بزنید',
        studentAbsenceList: 'گزارش غیبت ها',
        updateUserProfile:'بروزرسانی پروفایل',
        maxPoint:'حداکثر امتیاز',
        survey:'ارزیابی',
        manageSurvey:'مدیریت ارزیابی',
        discussionStudies:'مطالعات و مباحثات',
        agents:'نمایندگان',
        classroomAbsence: 'مدیریت غیبت ها',
        selectAgentClassroom: 'انتخاب نمایندگان کلاس',
        downloadExcel: 'دانلود اکسل',
        attendanceList: 'لیست حضور و غیاب',
        classroomList: 'کلاس های برگزار شده',
        classroom: 'کلاس درس',
        standardCourseList: 'دروس معیار',
        standardCourses: 'دروس معیار',
        courseList: 'لیست درس ها',
        courses: 'درس ها',
        course: 'درس',
        dashboard: "داشبورد",
        base: "اطلاعات دوره",
        transaction: "تراکنش ها",
        business: "کسب و کار",
        action: "رفتار",
        attribute: "خصوصیات",
        countingUnit: "واحدهای شمارشی",
        entityCategory: "کالا",
        merchantCategory: "دسته بندی پذیرنده",
        role: "نقش",
        subSystem: "زیر سیستم",
        subsystemAction: "عملیات زیر سیستم",
        agency: "نمایندگان",
        branch: "شعبه",
        branchAttribute: "خصوصیات شعبه",
        branchUserAttribute: "خصوصیات کاربر شعبه",
        branchUserRole: "نقش کاربر شعبه",
        branchUserRoleAction: "رفتار نقش کاربر",
        entity: "موجودیت",
        merchant: "پذیرنده",
        user: "کاربر",
        transactionDetail: "جزئیات تراکنش",
        transactionHeader: "تیتر تراکنش",
        createTransaction: "ایجاد تراکنش",
        customer: "مشتری",
        card: "کارت ها",
        cardGroup: "گروه های کارت",
        branchGroup: "گروه شعبه",
        userCategory: "گروه کاربر",
        manualCategory: "گروه های دستی",
        pointCategory: "گروه های امتیازی",
        metricCategory: "گروه های متریکی",
        selectUsers: "انتخاب کاربران",
        attributeUser: "خصوصیات کاربر",
        attributeBranch: "خصوصیات شعبه",
        attributeEntity: "خصوصیات کالا",
        selectSubsystems: "انتخاب زیر سیستم",
        selectMerchantAttribute: "انتخاب خصوصیات های پذیرنده",
        selectBranchAttribute: "انتخاب خصوصیات های شعبه",
        selectUserAttribute: "انتخاب خصوصیات های کاربر",
        memberSegmentation: "گروه اعضا",
        mandatory: 'اجباری',
        attributeRole: 'خصوصیات نقش',
        attributeAction: 'خصوصیات رفتار',
        select: 'انتخاب کنید',
        adminManagementPanel: 'پنل مدیریتی ادمین',
        accessMerchantDialog: 'دسترسی های پذیرنده',
        manageHappyCall: 'مدیریت هپی کال',
        tickets: 'تیکت ها',
        importData: 'ایمپورت دیتا',
        FAQ: 'سوالات متداول',
        changeLanguage: 'تغییر زبان',
        save: 'ذخیره',
        close: 'بستن',
        edit: 'ویرایش',
        delete: 'حذف',
        cancel: 'انصراف',
        search: 'جستجو',
        operations: 'عملیات',
        panelSMSSetting: 'تنظیمات پنل پیامک',
        approvedAndSendSMS: 'تایید و ارسال پیامک',
        approvedAndSendEmail: 'تایید و ارسال ایمیل',
        accesses: 'دسترسی ها',
        accessToMenu: 'دسترسی به منوها',
        accessToRoles: 'دسترسی به نقش ها',
        accessToActions: 'دسترسی به رفتارها',
        accessToEntityCategory: 'دسترسی به گروه Entity',
        merchantSetting: 'تنظیمات پذیرنده',
        newBranch: 'تعریف شعبه جدید',
        specialSectionUsers: 'بخش ویژه کاربران',
        newUser: 'تعریف کاربر جدید',
        relatedRoles: 'نقش های مرتبط',
        memberCategory: 'گروه های اعضا',
        giftsCategory: 'گروه های هدیه',
        serviceCategory: 'گروه های سرویس',
        transactions: 'تراکنش ها',
        merchantsAndBranch: 'پذیرندگان و شعب',
        cardCategory: 'گروه های کارت',
        giftCategory: 'گروه های هدیه',
        next: 'بعدی',
        back: 'قبلی',
        nextLevel:'مرحله بعد',
        prevLevel:'مرحله قبل',
        agentManagementPanel: 'پنل مدیریتی نماینده',
        agentMerchants: 'پذیرندگان و شعب',
        agentTransaction: 'تراکنش ها',
        agentCards: 'کارت ها',
        agentHappycalManagment: 'مدیریت هپی کال',
        agentTickets: 'تیکت ها',
        agentImportData: 'ایمپورت دیتا',
        agentFAQ: 'سوالات متداول',
        agentSMSPanel: 'تنظیمات پنل پیامک',
        agentSendSMS: 'تایید و ارسال پیامک',
        agentSendEmail: 'تایید و ارسال ایمیل',
        settingAgentForMerchant: 'تنظیمات نماینده برای پذیرنده',
        initialSettings: 'تنظیمات اولیه',
        additionalSetting: 'تنظیمات تکمیلی',
        merchantAccess: 'دسترسی ها',
        merchantAccessToMenus: 'دسترسی به منو ها',
        merchantAccessToRols: 'دسترسی به نقش ها',
        merchantAccessToActions: 'دسترسی به رفتارها',
        merchantAccessToEntityGroups: 'دسترسی به گروه های Entity',
        merchantSettingSMS: 'تنظیمات پیامک',
        merchantSMSServiceSetting: 'تنظیمات پنل خدماتی',
        merchantSMSAdsSetting: 'تنظیمات پنل تبلیغاتی',
        merchantSMSServiceText: 'متن پیامک خدماتی',
        merchantEmailSetting: 'تنظیمات ایمیل',
        merchantRegisterSerial: 'رجیستر سریال',
        merchantReceiveAndPay: 'دریافت و پرداخت',
        merchantHappyCallSetting: 'تنظیمات هپی کال',
        merchantTransactionSetting: 'تنظیمات تراکنش',
        specialSectionActions: 'بخش ویژه رفتار ها',
        actionTransactionSetting: 'تنظیمات تراکنش',
        actionAccreditationSetting: 'تنظیمات اعتباردهی',
        actionScoringSetting: 'تنظیمات امتیازدهی',
        actionCoiningSetting: 'تنظیمات Coin دهی',
        actionSMSSetting: 'تنظیمات پیامک',
        actionHappycallSetting: 'تنظیمات هپی کال',
        specialSectionEntity: 'بخش ویژه Entity',
        entitiesCategory: 'گروه های Entity',
        definitionCharacteristics: 'تعریف خصوصیات',
        offers: 'آفر ها',
        campaigns: 'کمپین ها',
        definitionOffer: 'تعریف آفر',
        lottery: 'قرعه کشی',
        campaignsSendSMS: 'ارسال پیامک',
        offerTargets: 'تارگت ها',

        managerialSection: 'بخش مدیریتی',
        serialsManagement: 'مدیریت سریال ها',
        giftsManagement: 'مدیریت هدایا',
        fundsManagement: 'مدیریت صندوق ها',
        branchManagement: 'مدیریت شعب',
        messageManagement: 'مدیریت پیام ها',
        importDataManagement: 'مدیریت ایمپورت',
        registerImport: 'ایمپورت عضویت',
        transactionImport: 'ایمپورت تراکنش',
        creditImport: 'ایمپورت اعتبار اولیه',
        marketingManagement: 'مدیریت بازاریابی',
        purchaseServicesManagement: 'خرید خدمات',
        editProfileManagement: 'ویرایش پروفایل',
        reports: 'گزارشات',
        reportTransaction: 'گزارش تراکنش ها',
        reportCampaigns: 'گزارش کمپین ها',
        reportOffers: 'گزارش آفرها',
        reportLottery: 'گزارش قرعه کشی ها',
        reportMessages: 'گزارش پیام ها',
        reportTargets: 'گزارش تارگت ها',
        reportCustomers: 'گزارش مشتریان',
        reportMarketing: 'گزارش بازاریابی',
        reportHappyCall: 'گزارش هپی کال',
        reportEntities: 'گزارش کالا/خدمات',
        reportCards: 'گزارش کارنامه',
        reportBranches: 'گزارش شعب',
        reportFinancial: 'گزارش مالی',
        reportServiceSMS: 'گزارش پیامک خدماتی',
        reportAdsSMS: 'گزارش پیامک تبلیغاتی',
        reportSentEmail: 'گزارش ارسال ایمیل',
        reportGift: 'گزارش هدایا',
        reportUsers: 'گزارش کاربران',
        reportImportData: 'گزارش ایمپورت دیتا',
        makeReports: 'ساخت گزارشات',
        reportMaker: 'گزارش ساز',
        makeReportReferrals: 'گزارش مراجعات',
        makeReportVisitSite: 'گزارش بازدید از سایت',
        operatorPanel: 'پنل اپراتور(ثبت فاکتور)',
        operatorBuyTransaction: 'تراکنش خرید',
        operatorRegisterCustomer: 'عضویت مشتری',
        operatorBuyFactor: 'ثبت فاکتور خرید',
        operatorIncreaseCredit: 'افزایش اعتبار',
        operatorDeductionCredit: 'کسر از اعتبار',
        operatorDuplicateCard: 'کارت المثنی',
        reportReturnRegistration: 'ثبت مرجوعی',
        referralRegistration: 'ثبت مراجعه',
        entryExitRegistration: 'ثبت ورود و خروج',
        recordingLoads: 'تحویل بار',
        createPointConfig: 'ساخت تنظیمات امتیاز',
        frequencyIntervalsOfCustomerVisits: 'بازه های دفعات مراجعه مشتری',
        intervalsBetweenVisits: 'بازه های فاصله بین مراجعات (روز)',
        customerPaymentAmountRanges: 'بازه های مبلغ پرداختی مشتری (ریال)',
        from: 'از',
        to: 'تا',
        coefficients: 'ضرایب',
        manageItems: 'مدیریت آیتم ها',
        paye: 'دوره',
        settings: 'تنظیمات',
        major: 'رشته',
        userList: 'لیست کاربران',
        users: 'کاربران',
        studentList: 'لیست دانش پژوهان',
        students: 'دانش پژوهان',
        teacherList: 'لیست اساتید',
        teachers: 'اساتید',
        employeeList: 'لیست کارمندان',
        employees: 'کارمندان',
        classroomLeaves:'مرخصی ها',
        inquiry:'نمایش نتیجه',
        books: 'کتابخانه',
        reset: 'بازنشانی',
        resetFilter: 'بازنشانی فیلتر',
    },
    form: {
        studentAcademicStatus: 'وضعیت علمی دانش پژوه',
        percentAbsenceChart:'نمودار درصد غیبت ها',
        absenceChartByTeacher:'نمودار درصد غیبت‌ها بر اساس استاد',
        absenceChartByCourse:'نمودار درصد غیبت‌ها بر اساس درس',
        absenceChartByMajor:'نمودار درصد غیبت‌ها بر اساس رشته',
        absenceChartByPaye:'نمودار درصد غیبت‌ها بر اساس پایه',
        lagDistributionChart:'نمودار توزیع تاخیر',
        countAbsence:'تعداد غیبت',
        percentAbsence:'درصد غیبت',
        lagExpel:'اخراج',
        lagWithdraw:'انصراف',
        averageAbsencePercent:'میانگین درصد غیبت',
        chartOverTimeSubtitle:'روند تغییرات درصد غیبت‌ها در روزهای ثبت شده',
        chartDetailsSubtitle:'تحلیل آماری به تفکیک عوامل مختلف',
        noDataFound:'داده‌ای برای نمایش یافت نشد',
        noDataSubtitle:'برای این بازه یا دسته‌بندی اطلاعاتی ثبت نشده است',
        refreshChart:'تازه‌سازی داده‌ها',
        verticalBar:'نمودار ستونی',
        horizontalBar:'نمودار افقی',
        totalLags:'درصد تاخیر از کل حضور',
        totalLagSubtitle:'از کل حضور دانش‌پژوهان',
        highestAbsenceCourse:'بیشترین غیبت در درس',
        highestAbsenceTeacher:'بیشترین غیبت در کلاس استاد',
        totalRecords:'تعداد کل موارد',
        notAvailable:'نامشخص',
        dashboardWelcomeTitle:'به سامانه خوش آمدید',
        dashboardWelcomeSubtitle:'پنل آمار و مدیریت حضور و غیاب',
        studentAndAbsenceChart:'نمودار غیبت دانشپژوهان/کلاس',
        formTimeToAll:'زمان شروع و پایان کلی',
        formDaysOfWeekByTime:'زمان شروع و پایان به تفکیک روز هفته',
        classAttendanceAnnouncement:'در کلاس حضور داشتم',
        showThreePredictStudentGrades:'پیش بینی سه نمره آینده با هوش مصنوعی',
        userCourses:'دروس دانش پژوه',
        newLevel:'پایه تحصیلی جدید',
        newTuitionPayment:'پرداخت شهریه جدید',
        userFinancial:'اطلاعات مالی',
        newFinancialSetting:'تنظیمات مالی جدید',
        newReportCard:'کارنامه جدید',
        evaluationActionsMaxValue:'حداکثر امتیاز رفتار ها',
        newActionGrade:'نمره رفتار جدید',
        newPropaganda:'ثبت سابقه تبلیغی',
        profilePropaganda:'اطلاعات تبلیغی',
        userInformation:'اطلاعات کاربر',
        showAbsences:'نمایش غیبت ها',
        reception:'پذیرش',
        manyFieldNotFill:'بعضی از فیلد ها پر نشده اند',
        saveInformation:'ذخیره اطلاعات',
        titleOfMenusInPermissions:'این نقش به کدام منو ها دسترسی داشته باشد ؟',
        subTitleMajorPayePermission:'در صورتی که مقداری ست نشده باشد، به تمام رشته ها و دوره ها دسترسی خواهد داشت',
        thisAccessIsOnlyAppliedInReportSection:'این دسترسی فقط در بخش گزارشات اعمال میشود',
        settingPermission:'تنظیمات دسترسی',
        newPermission:'دسترسی جدید',
        newSetting:'تنظیمات جدید',
        systemSettings:'تنظیمات کلی سیستم',
        classroomList:'لیست دروس',
        disableSelectedClasses:'غیر فعال کردن کلاس های انتخاب شده',
        collectiveEntryOfScores:'ورود جمعی نمرات',
        newGrade:'نمره جدید',
        CV:'رزومه',
        UploadCV:'بارگزاری رزومه',
        newSurvey:'ارزیابی جدید',
        newClassroomLeave:'مرخصی جدید',
        allCountAbsence: 'کل غیبت ها',
        allCountAcceptedAbsence: 'تایید شده',
        allCountNotAcceptedAbsence: 'تایید نشده',
        allCountNotRequestedAbsence: 'درخواست نظر نشده',
        allCountRequestExcuseNotManaged: 'درخواست نظر شده',
        allCountVisitingInPersonAbsence: 'مراجعه حضوری',
        selectAgentsClassroom: 'انتخاب نمایندگان کلاس',
        showStudents: 'نمایش دانش پژوهان',
        newClassroom: 'کلاس درس جدید',
        newStandardCourses: 'درس معیار جدید',
        newCourse: 'درس جدید',
        newStudent: 'دانش پژوه جدید',
        selectGroupMember: 'انتخاب گروه اعضا',
        newAction: "رفتار جدید",
        newAttribute: "خصوصیات جدید",
        newCountingUnit: "واحدهای شمارشی جدید",
        newEntityCategory: "دسته بندی کالای جدید",
        newMerchantCategory: "دسته بندی پذیرنده جدید",
        newRole: "نقش جدید",
        newSubSystem: "زیر سیستم جدید",
        newAgency: "نمایندگی جدید",
        newBranch: "شعبه جدید",
        newBranchAttribute: "خصوصیات شعبه جدید",
        newBranchUserAttribute: "خصوصیات کاربر شعبه جدید",
        newBranchUserRole: "نقش کاربر شعبه جدید",
        newBranchUserRoleAction: "رفتار نقش کاربر جدید",
        newEntity: "موجودیت جدید",
        newMerchant: "پذیرنده جدید",
        newUser: "کاربر جدید",
        newCustomer: "مشتری جدید",
        newTransactionDetail: "جزئیات تراکنش جدید",
        newTransactionHeader: "تیتر تراکنش جدید",
        newSubsystemAction: "عملیات زیر سیستم جدید",
        newTransaction: "تراکنش جدید",
        newMemberCategory: "گروه اعضا جدید",
        newMetricSegmentation: "گروه متریک جدید",
        edit: "ویرایش",
        delete: "حذف",
        close: "بستن",
        save: "ذخیره",
        add: "افزودن",
        signIn: "ورود",
        signInToSystem: "ورود به سیستم مدیریت",
        search: "جستجو",
        searchCustomers: "جستجو مشتریان",
        selectBranch: "انتخاب شعبه",
        signOut: "خروج",
        newManualCategory: "گروه دستی جدید",
        selectAll: "انتخاب همه",
        newPointCategory: "گروه امتیازی جدید",
        config: "پیکربندی",

        showMerchantSubsystems: "نمایش زیرسیستم های پذیرنده",
        showBranchAttribute: "نمایش خصوصیات های شعبه",
        showUserAttribute: "نمایش خصوصیات های کاربر",
        showSubbranches: "نمایش شعبه های زیرمجموعه",
        showAction: "نمایش رفتار",
        selectAttribute: "انتخاب خصوصیات",
        relationRoles: 'نقش های مرتبط',
        mainRole: 'نفش اصلی',
        selectMainRole: 'انتخاب نفش اصلی',
        selectAction: 'انتخاب رفتار',
        selectRole: 'انتخاب نقش',
        changeStatus: 'تغییر وضعیت',
        warning: 'اخطار',
        editProfile: 'ویرایش پروفایل',
        transactions: 'تراکنش ها',
        sendSms: 'ارسال پیامک',
        location: 'موقعیت مکانی',
        allCustomers: 'تعداد کل مشتریان',
        allTransactions: 'تعداد کل تراکنش ها',
        totalSales: 'جمع کل فروش',
        totalCreditIssued: 'کل اعتبار صادر شده',
        showMembers: 'نمایش اعضا',
        isActive: 'فعال/غیر فعال',
        gift: 'هدیه',
        newCardCategory: 'گروه کارت جدید',
        newGiftCategory: 'گروه هدیه جدید',
        newServiceCategory: 'گروه سرویس جدید',
        newMetricCategory: 'گروه متریکی جدید',
        selectMember: 'انتخاب عضو',
        selectCardGroup: 'انتخاب گروه کارت',
        metricCategory: 'گروه بندی متریکی',
        selectTargetMerchant: 'انتخاب پذیرنده هدف',
        selectTargetEntity: 'انتخاب Entity هدف',
        selectTargetAction: 'انتخاب رفتار هدف',
        newTransactionSetting: 'تنظیمات تراکنش جدید',
        newActionAccreditationSetting: 'تنظیمات اعتباردهی جدید',
        newCreatePointConfig: 'تنظیمات امتیاز جدید',
        showItems: 'نمایش آیتم ها',
        newItem: 'آیتم جدید',
        campaignName: 'نام کمپین',
        selectMetricGroup: 'انتخاب گروه متریکی',
        offerCondition: 'شرط آفر',
        offerReceiver: 'گیرنده آفر',
        offerAward: 'جایزه آفر',
        campaignSetting: 'تنظیمات کمپین',
        expireDateOffer: 'تاریخ انقضای آفر دریافتی',
        expireDateOfferDescription: 'آفری که مشتری دریافت کرده است (در صورت عدم استفاده) پس از این تاریخ از بین خواهد رفت',
        messageAfterReceiveOffer: 'متن پیامک بعد از تعلق آفر به مشتری',
        messageAfterReceiveOfferDescription: 'این متن بعد از تعلق گرفتن آفر به صورت زیر اطلاع رسانی میشود',
        messageAfterReceiveOfferStartText: 'دریافت ----- ریال بیشتر به خاطر',
        messageAfterReceiveOfferEndText: 'مجموع اعتبار ----- ریال',
        isReceiveMessage: 'در صورت اختصاص به مشتری پیامک ارسال شود',
        notifyingCustomerOfTheOffer: 'اطلاع رسانی آفر به مشتری',
        notifyingCustomerOfTheOfferDescription: 'متن اطلاع رسانی و پیامک ارسالی متنی که می خواهید در قالب پیامک و نوتیفیکیشن برای مشتری ها ارسال شود را در کادر زیر تایپ کنید.\n' +
            'این متن پس از ثبت آفر بصورت خودکار برای مشتری ها ارسال می شود.',
        isNotifyingCustomerOfTheOffer: 'ارسال پیام به مشتری جهت اطلاع رسانی(در صورت فعال بودن موقع ثبت اطلاعات برای مشتریان انتخابی پیامک ارسال خواهد شد)',
        notifyingToAppCustomers: 'اطلاع رسانی آفر به اپ مشتری',
        isNotifyingToAppCustomersDescription: 'متن پیام ارسالی متنی که می خواهید در قالب پیام اپ برای مشتری ها ارسال شود را در کادر زیر تایپ کنید.\n' +
            'این متن پس از ثبت آفر بصورت خودکار برای مشتری ها ارسال می شود.\n',
        isNotifyingToAppCustomers: 'این پیام به اپ مشتریان شامل ارسال شود',
        selectManualCategory: 'انتخاب گروه های دستی',
        register: 'ثبت نام',
        newPaye: 'دوره جدید',
        newMajor: 'رشته جدید',
        newTeacher: 'استاد جدید',
        newEmployee: 'کارمند جدید',
        allCountLag:'تاخیر ها',
        sendNotifications:'ارسال نوتیفیکیشن',
        title: 'تیتر',
        body: 'متن',
        sendNotification:'ارسال نوتیفیکیشن',
        reset: 'بازنشانی',
        actions: 'عملیات',
    },
    fieldName: {
        allRecords: 'تعداد کل رکوردها',
        recordsCount: 'تعداد رکوردها',
        course: 'درس',
        onlyImageFiles: 'فقط فایل‌های تصویری مجاز است',
        awardeAmountFromPoint:'تعلق امتیاز از درصد امتیاز',
        classType:'نوع کلاس',
        deleteSurveys:'حذف ارزیابی',
        rankInCourse:'رتبه در کلاس',
        survayGrade:'ارزیابی',
        classroomPointReport:'امتیاز نظم',
        studentAbsenceCourseCount :'تعداد غیبت',
        totalClassSessions: 'تعداد کلاس',
        avgAllGrade:'میانگین نمرات',
        classroomGrade:'نمره کلاسی',
        writtenGrade: 'نمره کتبی',
        loadStudentsByPaye: "بارگذاری دانشپژوهان بر اساس پایه",
        levelAchievement:'سطح موفقیت',
        year : 'سال',
        achievementsList:'لیست موفقیت ها',
        achievements:'موفقیت ها',
        descriptionStudentTakenLeave:'توضیحات دانش پژوه در مرخصی',
        newPassword:'رمزعبور جدید',
        resalahTitleLevel3:'موضوع پایان نامه سطح 3',
        resalahTitleLevel4:'موضوع پایان نامه سطح 4',
        specializedEducationInfo:'چند سال تحصیلات تخصصی داشته اید و در چه رشته هایی',
        specializedTeachingInfo:'چند سال تدریس تخصصی داشته اید و در چه رشته هایی',
        teachingExperiences:'سوابق تدریس',
        researchRecords:'سوابق پژوهشی',
        academicEducations:'تحصیلات غیر حوزوی (دانشگاهی)',
        interests:'علاقه‌مندی‌ها و توانمندی‌ها',
        executiveExperiences:'سوابق اجرایی و مدیریتی',
        subject:'عنوان درس',
        institution:'محل تدریس / مرکز آموزشی',
        startYear:'سال شروع',
        endYear:'سال پایان',
        degreeLevel:'مقطع تحصیلی',
        fieldOfStudy:'رشته تحصیلی',
        university:'نام دانشگاه / موسسه',
        graduationYear:'سال فارغ‌التحصیلی',
        gpa:'معدل',
        publisher:'ناشر / نشریه / همایش',
        researchType:'نوع اثر',
        responsibility:'سمت / مسئولیت',
        organization:'سازمان / نهاد / موسسه',
        livelihoodInformation:'اطلاعات معیشتی',
        manufactureYear:'سال تولید خودرو',
        licensePlateNumber:'شماره پلاک خودرو',
        vehicleType:'نوع خودرو',
        housingType:'نوع مسکن',
        incomeSufficiency:'آیا مجموع درآمد شما، جهت هزینه های زندگی متناسب با زی و شأن طلبگی، کفایت میکند؟',
        otherIncomeSources:'آیا درآمدی غیر از شهریه، تدریس و یارانه دارید؟',
        monthlyInstallmentAverage:'میانگین اقساط ماهیانه',
        createDateTakenLeave:'تاریخ ایجاد مرخصی',
        isCreateLeave:'مرخصی ایجاد شود ؟',
        minimumRequiredScore: 'حداقل نمره برای تعلق گرفتن امتیاز نمرات',
        isCourseIncludedInDisciplineScore:'درس در امتیاز نظم محاسبه شود؟',
        sumPointReportSetting:'جمع امتیاز های ارزیابی',
        countAcceptableAbsenceWithLeave:'غیبت تش با م',
        countUnAcceptableMoreThanTen:'تاخیر بالای 10 تن',
        countAcceptableMoreThanTen:'تاخیر بالای 10 ت',
        countUnacceptableAbsenceWithLeave:'غیبت تن با م',
        countAcceptableAbsence:'غیبت تش بدون م',
        countUnacceptableAbsence:'غیبت تن بدون م',
        countDelayLessThanTen:'حضور بعد از استاد (تاخیر زیر 10) ت',
        countUnacceptableDelayLessThanTen:'حضور بعد از استاد (تاخیر زیر 10) تن',
        showAttendancesAbsent:'نمایش غیبت های کلاس هایی که حضور و غیاب شده اند',
        absenceOfOfficialHoliday:'علت تعطیلی',
        absenceOfStudents:'علت غیبت شاگردان',
        absenceOfOther:'علت دیگر',
        absenceOfUnknown:'علت نامشخص',
        attendanceStatus:'وضعیت حضور',
        showAttendances:'نمایش حضورها',
        showDetailSurvey : "نمایش ریز ارزیابی",
        allAttendance:'کل حضور',
        sumScoreValue:'جمع نمره',
        sumMainValue:'جمع سقف نمره',
        mainValue:'سقف نمره',
        manageSurveyName:'نام ارزیابی',
        dependentsList:'لیست وابستگان',
        employmentStatus:'شاغل هست ؟',
        education:'تحصیلات',
        sicks:'بیماری ها',
        identificationNumber:'شماره شناسنامه',
        saturday: 'شنبه',
        sunday: 'یکشنبه',
        monday: 'دوشنبه',
        tuesday: 'سه شنبه',
        wednesday: 'چهارشنبه',
        thursday: 'پنجشنبه',
        friday: 'جمعه',
        agentsName:'نام نمایندگان',
        allowingStudentToReportAttend:'اجازه اعلام حضور به دانش پژوه',
        dependentKind:'نوع وابسته',
        dependents:'وابستگان',
        principlePresent:'اصل حضور باشد؟',
        levelName: 'پایه تحصیلی',
        level:'پایه تحصیلی',
        totalReceived:'دریافتی نهایی (ریال)',
        userAddsAmounts:'اضافه دریافت (ریال)',
        pointsAmount:'مبلغ امتیاز (ریال)',
        addsAmount:'اضافه پرداخت ها',
        amount:'مبلغ (ریال)',
        tuitionAmount:'مبلغ شهریه (ریال)',
        maximumPointsAmount:'مبلغ اختصاصی برای سقف امتیاز(ریال)',
        marriageAmount:'مبلغ حق تاهل(ریال)',
        amountOfChild:'مبلغ حق اولاد به ازای هر فرزند(ریال)',
        deductions:'کسورات',
        checkPassFail:'وضعیت دانش پژوه در درس',
        maxAbsenceConfirmedUnit:'حداکثر غیبت موجه به ازای یک واخد درسی',
        maxAbsenceDisConfirmedUnit:'حداکثر غیبت عیرموجه به ازای یک واخد درسی',
        dayOfMonthReportCard:'روز ایجاد کارنامه در ماه',
        gradeActions:'نمره رفتار ها',
        reportCardType:'نوع کارنامه',
        percentPoint:'درصد امتیاز',
        maxPoint:'حداکثر امتیاز',
        sumPoint:'جمع امتیاز',
        gradesYearly:'نمرات سالانه',
        gradesTerm:'نمرات ترم',
        gradesMidterm:'نمرات میان ترم',
        gradesWeekly:'نمرات هفتگی',
        gradesMonthly:'نمرات ماهانه',
        gradesDaily:'نمرات روزانه',
        survey:'ارزیابی',
        discipline:'نظم',
        reportCardStartDate:'تاریخ شروع ایجاد کارنامه',
        reportCardEndDate:'تاریخ پایان ایجاد کارنامه',
        evaluationActionTitle:'نام رفتار',
        scoreDate:'تاریخ نمره',
        selectActions:'انتخاب رفتار',
        maxValue:'حداکثر مقدار',
        withMerchant:'با موسسه',
        individualOrGroup:'فردی یا گروهی',
        areaPropaganda:'حیطه تبلیغ',
        professionalPropaganda:'تبلیغ تخصصی',
        numberYearAdvertisingHistory:'چند سال سابقه تبلیغی دارید؟',
        feghExam:'آزمون فقه',
        osulExam: 'آزمون اصول',
        comprehensiveScores:'نتایج امتحانات',
        locationPropaganda:'مکان تبلیغ',
        title:'عنوان',
        time:'زمان',
        influenceAndInfluence:'حوزه نفوذ و تاثیرگذاری',
        placeforSendingGroup:'امکان هماهنگی مکان تبلیغی برای اعزام گروهی',
        fixedAdvertisingLocation:'مکان تبلیغی ثابت',
        wifesAbility:'سوابق و توانایی های تبلیغی همسر',
        advertisingTrainingCourses:'دوره های آموزشی تبلیغی',
        withMerchantFileNumber:'شماره پرونده تبلیغی مرکز',
        nahadFileNumber:'شماره پرونده تبلیغی نهاد رهبری در دانشگاهها',
        defaFileNumber:'شماره پرونده تبلیغی وزارت دفاع',
        farajaFileNumber:'شماره پرونده تبلیغی نیروی انتظامی',
        arteshFileNumber:'شماره پرونده تبلیغی ارتش',
        sepahFileNumber:'شماره پرونده تبلیغی سپاه',
        oghafFileNumber:'شماره پرونده تبلیغی اوقاف',
        organizationtFileNumber:'شماره پرونده تبلیغی شمع',
        samtaFileNumber:'شماره پرونده تبلیغی سمتا',
        samavatFileNumber:'شماره پرونده تبلیغی سماوات',
        virtualPropaganda:'آدرس فعالیت های شما در فضای مجازی',
        village:'روستا',
        villageCity:'دهستان یا شهر',
        villageOrCity:'روستا یا شهر',
        part:'بخش',
        county:'شهرستان',
        province:'استان',
        remainingTime:'زمان باقیمانده',
        timeNumberOfUnits:'زمان درس بر مبنای واحد',
        dividedCourseRequest:'به تفکیک درس',
        writtenExam:'آزمون کتبی',
        cognitiveOralExam:'امتحان شفاهی شناختی',
        scientificOralExam:'امتحان شفاهی علمی',
        resultOfExamPeriod:'نتیجه دوره اختبار',
        isFatherAlive:'پدر در قد حیات هست ؟',
        marriageDate:'تاریخ ازدواج',
        birthDate:'تاریخ تولد',
        uploadYourTranscriptFile:'بارگزاری تصویر ریز نمرات',
        uploadAcademicEvaluationFile:'بارگزاری تصویر ارزیابی تحصیلی',
        countScorePeriod:'تعداد نمرات دوره',
        sumScorePeriod:'جمع نمرات دوره',
        avgScorePeriod:'میانگین نمرات دوره',
        countAllScore:'تعداد کل نمرات',
        sumAllScore:'جمع کل نمرات',
        avgAllScore:'میانگین کل نمرات',
        sendTo:'ارسال به',
        automaticClassroomCreation:'ایجاد اتوماتیک کلاس درس',
        classroomPoint:'امتیاز نظم کلاسی',
        getMaxPointsWithMinWorkSPD:'گرفتن حداکثر امتیاز مباحثه و مطالعه و پیش مطالعه با حداقل کار',
        applyValidationMaxSPD:'ولیدیشن حداکثر مقدار مطالعه و مباحثه و پیش مطالعه اعمال شود؟',
        classroomIsNotAbsence:'کلاس هایی که حضور و غیاب نشده اند',
        mainDiscussion:'جمع اصلی مباحثه',
        mainStudy:'جمع اصلی مطالعه',
        mainPreStudy:'جمع اصلی پیش مطالعه',
        avgDiscussion:'امتیاز مباحثه',
        avgStudy:'امتیاز مطالعه',
        avgPreStudy:'امتیاز پیش مطالعه',
        maxPointSurvey:'حداکثر امتیاز ارزیابی',
        closingAfterMinClassroomAttendance:'حضور و غیاب کلاس بعد از چند دقیقه بسته شود',
        closingTimeClassroomAttendance:'حضور و غیاب کلاس زمان پایان کلاس، بسته شود یا خیر',
        maxAbsence:'حداکثر غیبت',
        maxAbsenceUnit:'حداکثر غیبت به ازای یک واحد درسی',
        timeOfAnyClassroom:'مقدار پیشفرض هر کلاس به دقیقه',
        maxPointDiscussion:'حداکثر امتیاز مباحثه',
        maxPointStudy:'حداکثر امتیاز مطالعه',
        maxPointPreStudy:'حداکثر امتیاز پیش مطالعه',
        maxPointGradesDaily:'حداکثر امتیاز نمرات روزانه',
        maxPointGradesWeekly:'حداکثر امتیاز نمرات هفتگی',
        maxPointGradesMonthly:'حداکثر امتیاز نمرات ماهانه',
        maxPointGradesMidterm:'حداکثر امتیاز نمرات میان ترم',
        maxPointGradesTerm:'حداکثر امتیاز نمرات ترم',
        maxPointGradesYearly:'حداکثر امتیاز نمرات سالیانه',
        maxPointDiscipline:'حداکثر امتیاز نظم به ازای درس واحد',
        minPointGradesDaily:'حداقل نمره روزانه',
        maxPointDisciplineForReport:'حداکثر امتیاز نظم موثر در کارنامه',
        showAllYearData:'نمایش اطلاعات کل سال ها',
        minPointGradesWeekly:'حداقل نمره هفتگی',
        minPointGradesMonthly:'حداقل نمره ماهانه',
        minPointGradesMidterm:'حداقل نمره میان ترم',
        minPointGradesTerm:'حداقل نمره ترم',
        minPointGradesYearly:'حداقل نمره سالیانه',
        deductionPointByUnacceptableAbsence:'مقدار کسر امتیاز بابت غیبت تایید نشده بدون مرخصی',
        deductionPointByAcceptableAbsence:'مقدار کسر امتیاز بابت یک غیبت تایید شده بدون مرخصی',
        deductionPointByUnacceptableAbsenceWithLeave:'مقدار کسر امتیاز بابت غیبت تایید نشده با مرخصی',
        deductionPointByAcceptableAbsenceWithLeave :'مقدار کسر امتیاز بابت غیبت تایید شده با مرخصی',
        deductionPointAnyDelayAcceptableMoreThanTen:'مقدار کسر امتیاز بابت هر تاخیر تایید شده بالای 10 دقیقه',
        deductionPointAnyDelayUnAcceptableMoreThanTen:'مقدار کسر امتیاز بابت هر دقیقه تاخیر تایید نشده بالای 10 دقیقه',
        deductionPointAnyDelayLessThanTen:'مقدار کسر امتیاز بابت هر تاخیر زیر 10 دقیقه',
        deductionPointUnacceptableAnyDelayLessThanTen:'مقدار کسر امتیاز بابت هر تاخیر  تایید نشده زیر 10 دقیقه',
        deductionPointAnyDelay:'مقدار کسر امتیاز بابت هر تاخیر',
        discussionStudiesBeforeDay:'تا چند روز بعد مباحثه و مطالعه باز باشد',
        salTahsili:'سال تحصیلی',
        attendanceDateTime:'زمان حضور و غیاب',
        attendanceBy:'حضور و غیاب توسط',
        allClassroomCount:'کل کلاس ها',
        allNotHeld:'کل برگزار نشده',
        absenceOfTheTeacher:'تعداد غیبت استاد',
        sumInsertedTime:'زمان کلاس اعلامی',
        sumClassroomTime:'زمان کلاس',
        scoreValue:'نمره',
        gradePeriod:'دوره امتحان',
        gradeType:'نوع امتحان',
        courseType:'نوع درس',
        allClassroomLeave:'مرخصی ها',
        confirmationLeave:'مرخصی تایید شده',
        visitingInPersonAbsence:'مراجعه حضوری',
        confirmationAbsence:'تایید شده',
        disapprovalAbsence:'تایید نشده',
        allAbsence:'کل غیبت ها',
        firstName:'نام',
        onlyZipFiles:'فقط فایل Zip یا RAR',
        downloadCV:'دانلود رزومه',
        uploadYourCV:'بروزرسانی رزومه',
        lagCount:'تعداد تاخیر',
        isTeacherAssistant:'استادیاری',
        items:'آیتم ها',
        question:'سوال',
        surveyType:'نوع ارزیابی',
        minute:'دقیقه',
        courseDate:'زمان درس',
        confirmStatus:'وضعیت تایید',
        isTakenLeave:'درخواست مرخصی',
        studentCount:'تعداد دانش پژوه',
        absenceCount:'تعداد غیبت',
        checkAll:'اعمال بر همه',
        saltahsili:'سال تحصیلی',
        showOnlyRequestedAbsenceNotManaged:'فقط نمایش در خواست نظر شده هایی که مدیریت نشده اند',
        managementDescription: 'توضیحات مدیریت',
        managementOpinion: 'نظر مدیریت',
        requestExcuse: 'درخواست عذر',
        studentName: 'نام دانش پژوه',
        createDateAbsence: 'زمان غیبت',
        selectTeacher: 'انتخاب استاد',
        selectCourse: 'انتخاب درس',
        reasonFailure: 'علت عدم تشکیل',
        discussionTime: 'زمان مباحثه (دقیقه)',
        studyTime: 'زمان مطالعه (دقیقه)',
        preStudyTime: 'زمان پیش مطالعه (دقیقه)',
        study: 'مطالعه',
        preStudy: 'پیش مطالعه',
        research: 'پژوهش',
        numberOfUnits: 'تعداد واحد',
        discussion: 'مباحثه',
        term: 'ترم',
        majorName: 'نام رشته',
        lagTime: 'مقدار تاخیر',
        createDateClassroom: 'زمان ایجاد کلاس',
        standardCourse: 'درس معیار',
        payeName: 'نام دوره ثبت نامی',
        selectedPayeName: 'نام دوره',
        parentsCourse: 'دروس پیش نیاز',
        students: 'دانش پژوهان',
        dayOfWeek: 'روز از هفته',
        startDate: 'تاریخ شروع',
        endDate: 'تاریخ پایان',
        description: 'توضیحات',
        fromTime: 'زمان شروع',
        endTime: 'زمان پایان',
        teacher: 'استاد',
        uploadYourImage: 'یک تصویر از خودتان بارگزاری کنید',
        uploadShShImage: 'بارگزاری تصویر شناسنامه',
        uploadMelliImage:'بارگزاری تصویر کارت ملی',
        name: "نام",
        family: "نام خانوادگی",
        phone: "تلفن",
        mobile: "موبایل",
        email: "ایمیل",
        address: "نشانی",
        managerName: "نام مدیر",
        managerFamily: "نام خانوادگی مدیر",
        action: "عملیات",
        operations: "عملیات",
        shSh: 'شماره شناسنامه',
        fatherName: 'نام پدر',
        childCount: 'تعداد فرزند',
        sh_hesab: 'شماره حساب',
        bankName: 'نام بانک',
        homeAddress: 'نشانی منزل',
        homePhone: 'تلفن منزل',
        password: "گذرواژه",
        isActive: "فعال است",
        langKey: "کلید زبان",
        companyName: "نام شرکت",
        brandName: "نام تجاری",
        // IsLeaf :"صفحه",
        attributesValue: "مقدار خصوصیات ها",
        isRequired: "اجباری است؟",
        minLength: "حداقل طول",
        maxLength: "حداکثر طول",
        value: "مقدار",
        // IsOwner:"مالک",
        registrationOriginType: "مبدا ثبت",
        quantity: "تعداد",
        totalValue: "مقدار کل",
        originType: "مبدا ثبت",
        unit: "واحد شمارش",
        childrenCount: "تعداد زیر مجموعه",
        entityName: " نام موجودیت",
        sumValue: "جمع مقدار",
        userCount: "تعداد کاربر",
        role: "نقش",
        roleName: "نام نقش",
        isLoginAllowed: "اجازه ورود دارد",
        subsystemName: "نام زیر سیستم",
        actionName: "نام رفتار",
        branch: "شعبه",
        attribute: "خصوصیات",
        branchUserRole: "نقش کاربر شعبه",
        merchantCategory: "دسته بندی پذیرنده",
        fieldType: "نوع فیلد",
        attributeType: "نوع خصوصیات",
        merchant: "پذیرنده",
        parentMerchant: "پذیرنده سطح بالا",
        frequentTimes: 'ضریب دفعات مراجعه',
        frequentDistanceTimes: 'ضریب فاصله مراجعه',
        frequentAmountPaid: 'ضریب مبلغ پرداختی',
        leaderRole: 'نقش اصلی',
        leaderName: 'نام نقش اصلی',
        subgroupRole: 'نقش زیرگروه',
        categoryName: 'نام گروه',
        sumInvoice: "جمع فاکتور",
        parentAttribute: "خصوصیات سر شاخه",
        descriptionMainRoleRelated: "در زمان تراکنش در صورت نداشتن این نقش، نقش به کاربر :",
        fromDate: "از تاریخ",
        toDate: 'تا تاریخ',
        country: 'کشور',
        city: 'شهر',
        userName: 'نام کاربری',
        transactionCount: 'تعداد تراکنش',
        transactionSum: 'جمع تراکنش',
        newUsers: 'عضو جدید',
        status: 'وضعیت',
        createDate: 'تاریخ ایجاد',
        expireDate: 'تاریخ انقضاء',
        lastName: 'نام خانوادگی',
        uploadLogo: 'بارگزاری لوگو',
        uploadQR: 'بارگزاری QR',
        location: 'مکان',
        jobCategory: 'گروه شغلی',
        gender: 'جنسیت',
        nationalCode: 'کد ملی',
        fund1: 'صندوق 1',
        fund2: 'صندوق 2',
        fund3: 'صندوق 3',
        merchantType: 'نوع پذیرنده',
        selectAgency: 'انتخاب نماینده',
        branchCount: 'تعداد شعبه',
        isInheritAccess: 'دسترسی های مدیر شعب به ارث',
        accessMerchant: 'دسترسی پذیرنده',
        subGroup1: 'زیر گروه سطح 1',
        subGroup2: 'زیر گروه سطح 2',
        subGroupCount: 'تعداد زیر گروه',
        headGroupName: 'نام سرگروه',
        headGroupRole: 'نقش سرگروه',
        subGroupRole: 'نقش زیر گروه',
        groupName: 'نام گروه',
        fromPoint: 'از امتیاز',
        toTop: 'به بالا',
        credit: 'اعتبار',
        roleGroup: 'گروه نقش',
        roleSubGroup: 'زیرگروه نقش',
        selectMember: 'انتخاب عضو',
        memberSubGroup: 'انتخاب زیرگروه عضو',
        selectCardGroup: 'انتخاب گروه کارت',
        selectLevels: 'انتخاب سطح',
        selectMetrics: 'انتخاب متریک',
        operator: 'عملگر',
        metricValue: 'مقدار متریک',
        nextMetric: 'متریک بعدی',
        selectEntity: 'انتخاب Entity',
        selectSubEntity: 'انتخاب زیر Entity',
        selectSubject: 'انتخاب Subject',
        formula: 'فرمول',
        selectParameter: 'انتخاب پارامتر',
        selectFOC: 'انتخاب FOC',
        selectAction: 'انتخاب رفتار',
        conditionApply: 'اعمال شرط',
        toman: 'ریال',
        minUsableCredit: 'حداقل اعتبار قابل استفاده',
        maxTransactionAllowed: 'سقف تراکنش مجاز',
        creditExpireDateBranch: 'تاریخ انقضای اعتبار گروهی/شعب',
        creditExpireDay: 'تاریخ انقضا',
        day: 'روز',
        percent: 'درصد',
        cash: 'نقد',
        customerCanUseCreditForOfTheirPurchases: 'مشتری برای چند درصد از خرید خود میتواند از اعتبارش استفاده کند',
        customerCanUseACertainPercentageOfHisCreditForEachPurchase: 'مشتری در هر بار خرید می تواند از چند درصد اعتبارش استفاده کند',
        creditNormalPercentageAllProductGroups: 'درصد اعتبار عادی دریافتی از سمت مشتری در تمام گروه های کالایی',
        productGroups: 'گروه های کالایی',
        creditPercentage: 'درصد اعتبار',
        productGroupName: 'گروه کالایی',
        selectMerchant: 'انتخاب پذیرنده',
        selectBranch: 'انتخاب شعبه',
        selectAttribute: 'انتخاب Attribute',
        mainRole: 'نقش اصلی',
        relatedRole: 'نقش مرتبط',
        discount: 'تخفیف',
        getMoreCoin: 'دریافت Coin بیشتر',
        getMorePoint: 'دریافت امتیاز بیشتر',
        pointFormula: 'فرمول دریافت امتیاز',
        forEach: 'بازای هر',
        receivesPoints: 'امتیاز دریافتی',
        receiveSpecialService: 'دریافت سرویس ویژه',
        receiveTheProduct: 'دریافت محصول',
        selectDate: 'انتخاب تاریخ',
        dayAfterGetCredit: 'روز بعد از تعلق آفر',
        sendSMSToAllCustomer: 'برای تمام مشتری ها ارسال شود',
        sendSMSToQualifyCustomer: 'فقط برای مشتری هایی که این آفر شامل حال آنها می شود، ارسال شود',
        selectManualCategory: 'انتخاب گروه دستی',
        selectSubManualCategory: 'انتخاب زیر گروه دستی',
        selectGroupMember: 'انتخاب گروه عضو',
        selectPointCategory: 'انتخاب گروه امتیازی',
        isMarried: 'وضعیت تاهل',
        userRole: 'نقش کاربر',
        employeeNumber: 'کد کارمندی',
        studentNumber: 'کد دانش پژوه ',
        teacherNumber: 'کد استادی',
        paye: 'دوره',
        major: 'رشته',
        nameOrFamilyOrCellphone: 'نام یا نام خانوادگی یا شماره موبایل',
        employeeGroup: 'گروه کارمند',
        employees:'کارمندان',
        teachers:'اساتید',
        courseName: 'نام درس',
        teacherName: 'نام استاد',
        statusTakenLeave:'وضعیت مرخصی',
        statusConfirm:'وضعیت تایید',
        cellphone:'موبایل',
        fullName:'نام',
        sumMainPoint:'جمع اصلی امتیاز',
        sumPersonPoint:'جمع امتیاز فرد',
        avgPoint:'میانگین امتیاز',
        elapsedTime:'زمان سپری شده',
        realClassroomTime:'زمان واقعی برگزاری کلاس درس (دقیقه)',
        selectUsersOfGroup:'انتخاب کاربران از گروه',
        postalCode:'کد پستی',
        mahal_t:'محل تولد',
        hozehId:'کد مرکز مدیریت',
        yearEnteringHozeh:'سال ورود به حوزه',
        cellphone2:'شماره همراه دوم',
        cellphoneInCyberspace : 'شماره همراه در فضای مجازی',
        previousSchoolName:'نام محل تحصیل قبل',
        previousSchoolCellphone:'شماره تلفن محل تحصیل قبل',
        previousSchoolTeacherCellphone:'شماره یکی از اساتید',
        fatherJob:'شغل پدر',
        fatherCellphone:'شماره موبایل پدر',
        selectedPayeNameInRegister:'قصد شرکت در کدام پایه تحصیلی را دارید ؟',
        selectedPayeForResult : 'در چه پایه ای ثبت نام کردید ؟ '
    },
    enums: {
        classType:{
            normal: 'کلاس عادی آموزشی',
            teachingAssistant:'کلاس استادیاری',
            counseling:'کلاس مشاوره',
            general:'کلاس عمومی',
            specialized:'کلاس تخصصی'
        },
        achievementLevel:{
            national:'کشوری',
            provincial:'استانی',
            international:'بین المللی'
        },
        housingType:{
            personal: 'شخصی',
            supportive:'حمایتی',
            rental : 'استیجاری ',
        },
        dependentKind:{
            wife:'همسر',
            children:'فرزندان',
        },
        checkPassFail:{
            fail:'حذف شده',
            onPerforming:'در حال برگزاری',
            pass:'پاس شده'
        },
        reportCardType:{
            weekly:'هفتگی',
            monthly:'ماهانه',
            yearly:'سالانه'
        },
        professionalPropaganda:{
            economy :'اقتصاد',
            education :'تربیت',
            media :'رسانه',
            legalIssues :'مباحث حقوقی',
            family :'خانواده',
            children_adolescents :'کودک و نوجوان',
            mahdavit :'مهدویت',
            commandments :'احکام',
            others :'سایر'
        },
        areaPropaganda:{
            mosque :'مسجد',
            board : 'هیئت',
            schools :'مدارس',
            kidsAndTeenager : 'کودک و نوجوان',
            student : 'دانشجویی',
            cyberspace : 'فضای مجازی',
            publicPlaces :'اماکن عمومی',
            others :'سایر'
        },
        individualOrGroup:{
            individual: 'فردی',
            group: 'گروهی'
        },
        gradeType: {
            written:'کتبی',
            oral:'شفاهی',
            research:'پژوهشی',
            classroom:'کلاسی'
        },
        gradePeriod:{
            daily:'روزانه',
            weekly:'هفتگی',
            monthly:'ماهانه',
            midterm:'میان ترم',
            term:'ترم',
            yearly:'سالیانه'
        },
        courseType:{
            allCourse:'همه درس ها',
            normalCourse:'درس های عادی',
            assistantCourse:'استادیاری'
        },
        surveyType:{
            students:'ارزیابی استاد نسبت به دانش پژوهان',
            teachers:'ارزیابی استاد مشاوره نسبت به دانش پژوهان',
            teachersAide:'ارزیابی استادیار نسبت به دانش پژوهان',
            general:'ارزیابی استاد کلاس عمومی نسبت به دانش پژوهان',
            specialized:'ارزیابی استاد تخصصی نسبت به دانش پژوهان'
        },
        managementOpinion: {
            disapproval: 'تایید نشده',
            confirmation: 'تایید شده',
            visitingInPerson: 'مراجعه حضوری'
        },
        reasonFailure: {
            unknown: 'نامشخص',
            absenceOfTheTeacher: 'غیبت استاد',
            officialHoliday: 'تعطیلی رسمی',
            absenceOfStudents: 'غیبت دانش پژوهان',
            other:'دیگر'
        },
        isActive: {
            active: "فعال",
            deactivate: "غیر فعال"
        },
        yesNo: {
            yes: "بله",
            no: "خیر"
        },
        payeName: {
            1: "پایه 1",
            2: "پایه 2",
            3: "پایه 3",
            4: "پایه 4",
            5: "پایه 5",
            6: "پایه 6",
            7: "پایه 7",
            8: "پایه 8",
            9: "پایه 9",
            10: "پایه 10",
            kharejOmoomi: "خارج عمومی",
            kharejTakhassosiEgtesad: "خارج تخصصی اقتصاد",
            kharejTakhassosiTarbiat: "خارج تخصصی تربیت",
            kharejTakhassosiSiasat: "خارج تخصصی سیاست",
            kharejTakhassosiFarhang: "خارج تخصصی فرهنگ",
            kharejTakhassosiHogoghOmoomi: "خارج تخصصی حقوق عمومی",
            kharejTakhassosiHogoghTakhassosi: "خارج تخصصی حقوق خصوصی",
        },
        term: {
            firstHalfYear: "نیم سال اول",
            secoundHalfYear: "نیم سال دوم",
            summerHalfYear: 'ترم تابستان'
        },
        fieldType: {
            number: "عددی",
            string: "حروف",
            boolean: "منطقی",
            date: "تاریخ",
            singleChoice: "تک انتخابی",
            multiChoice: "چند انتخابی",
            lookup: "جستجو",
            lookupMultiSelect: "جستجو چند انتخابی",
            file: "فایل"
        },
        attributeType: {
            userAttribute: "خصوصیات کاربر",
            branchAttribute: "خصوصیات شعبه",
            entityAttribute: "خصوصیات کالا",
        },
        multiSelect: {
            option1: 'گزینه 1',
            option2: 'گزینه 2',
            option3: 'گزینه 3',
            option4: 'گزینه 4',
            option5: 'گزینه 5',
            option6: 'گزینه 6',
            option7: 'گزینه 7',
            option8: 'گزینه 8',
            option9: 'گزینه 9',
            option10: 'گزینه 10',
        },
        give: {
            toBeGiven: 'داده شود',
            notBeGiven: 'داده نشود'
        },
        condition: {
            conditionApplies: 'شرط اعمال میشود',
            conditionNotApplies: 'شرط اعمال نمیشود'
        },
        userRoles: {
            user: 'کاربر',
            student: 'دانش پژوه',
            teacher: 'استاد',
            employee: 'کارمند'
        },
        roles: {
            //users: 'Users',
            students: 'دانش پژوهان',
            teachers: 'اساتید',
            employees: 'کارمندان'
        },
        employeeGroups: {
            educationAssistant: 'معاونت آموزش',
            specializedEducationAssistant: 'معاونت آموزش تخصصی',
            researchAssistant: 'معاونت پژوهش',
            culturalAssistant: 'معاونت فرهنگی',
            ResponsibleStudents:'مسئول دوره'
        },
        dayOfWeek: {
            saturday: 'شنبه',
            sunday: 'یکشنبه',
            monday: 'دوشنبه',
            tuesday: 'سه شنبه',
            wednesday: 'چهارشنبه',
            thursday: 'پنجشنبه',
            friday: 'جمعه'
        },
        rollCall:{
            attendance: 'حاضر',
            absence:'غایب'
        }
    },
    successMsg: {
        successfulSave: "عملیات با موفقیت انجام شد",
        registerSuccessfulDesc:'ثبت نام شما با موفقیت انجام شد. بعد از بررسی های اولیه با شما تماس گرفته خواهد شد <br/> جهت آگاهی از اطلاعیه های پذیرش و زمان مصاحبه از طریق لینک، عضو کانال پذیرش مدرسه شوید'
    },
    infoMsg: {
        emptyTable: "داده ای وجود ندارد",
        loading: "دریافت اطلاعات...",
        underConstruction: 'در دست ساخت',
        profilePropagandaHistory:'سابقه تبلیغی خود را در کادر زیر وارد کنید'
    },
    warnMsg: {
        deleteRecord: "آیا میخواهید این رکورد را حذف کنید؟",
    },
    errorMsg: {
        recordNotFound: "رکورد پیدا نشد",
        mobileNotFound: "شماره موبایل مورد نظر پیدا نشد",
        notSelectedCustomer: "هیچ مشتری ای انتخاب نشده است",
        notSelectedEntity: "هیچ موجودیتی انتخاب نشده است",
        notSelectedBranch: "هیچ شعبه ای انتخاب نشده است",
        notAccessByFilterMajorPaye:'برای دسترسی لطفا رشته و دوره را انتخاب کنید',
        notAllowedForSelectedRole:'برای نقش انتخابی مجاز نیست',
        fillAllFields:'همه فیلد ها را پر کنید',
        dateIsRequired:'تاریخ را وارد کنید'
    },
    validateMsg: {
        required: "اجباری",
        email: "ایمیل اجباری است",
        invalidEmail: "ایمیل وارد شده صحیح نیست",
        passwordReq: "گذرواژه اجباری است",
        mobileOnly: "شماره وارد شده اشتباه است",
        numberPositive: "فقط اعداد مثبت",
        passwordLength: 'حداقل 6 کاراکتر وارد کنید',
        max1MB: 'حداکثر سایز فایل 1 مگابایت',
        max512KB: 'حداکثر سایز فایل 512 کیلو بایت',
        max2MB: 'حداکثر سایز فایل 2 مگابایت',
        maxNum:'حداکثر عدد ',
        nationalCode:'کد ملی وارد شده اشتباه است',
        year:'سال وارد شده اشتباه است'
    },
    db: {}
}
